import React from 'react';
import eConsultLogo from './eConsult-logo.svg';
import eConsultLogoReversed from './eConsult-logo-reversed.png';

export const EConsultLogo = () => <img src={eConsultLogo} alt="eConsult logo" />;

export const AltEConsultLogo = ({ className }) => <img src={eConsultLogoReversed} alt="eConsult logo" className={className} />;
